var $ = require('jquery');
var Marionette = require('backbone.marionette');
var RootView = require('./layout-view');
var Radio = require('backbone.radio');

// The Application Object is responsible for kicking off
// a Marionette application when its start function is called
//
// This application has a singular root Layout that is attached
// before it is started.  Other system components can listen
// for the application start event, and perform initialization
// on that event

// App-level Radio Channel
var routerChannel = Radio.channel('router');

module.exports = Marionette.Application.extend({

	setRootLayout: function () {
		this.root = new RootView();
		this.root.render();
	},

	// via marionette wires
	initialize: function() {
		this.$body = $(document.body);

		this.listenTo(routerChannel, {
      'before:enter:route' : this.onBeforeEnterRoute,
      'enter:route'        : this.onEnterRoute,
      'error:route'        : this.onErrorRoute
    });
	},

	onRoute: function(){
		console.log('ok, we are routing');
		this.trackPage();
	},

	onBeforeEnterRoute: function() {
    var self = this;
		console.log('onBeforeEnterRoute');
    // this.transitioning = true;
    // // Don't show for synchronous route changes
    // setTimeout(function() {
    //   if (self.transitioning) {
    //     nprogress.start();
    //   }
    // }, 0);
  },

  onEnterRoute: function() {
		console.log('onEnterRoute');
    // this.transitioning = false;
    // this.$body.scrollTop(0);
    // nprogress.done();
  },

  onErrorRoute: function() {
		console.log('onErrorRoute');
    // this.transitioning = false;
    // nprogress.done(true);
  }

	// Google Analytics tracking on route navigate
	// Backbone.history.navigate = _.wrap(Backbone.history.navigate,
	//   function(originalFunction, fragment, options) {
	//     try {
	//       console.log('BB root',Backbone.history.root);
	//       console.log('BB frag',fragment);
	//       ga('send', 'event', 'route', 'navigate', '/' + fragment);
	//     } finally {
	//       return originalFunction(this, arguments);
	//     }
	//   }
	// );
});
